import React from 'react';
import styled from 'styled-components';
import MatSpinner from '../../Mat/MatSpinner';

export default function BottomBar ({ doSave, buttonText, isLoading, error }) {
  const BottomBarContainer = styled.div`
    bottom: 0;
    left: 0;
    height: 60px;
    width: 100%;
    position: fixed;
    background-color: #193F77;
    overflow: hidden;
  `;

  const CustomButton = styled.button`
    width: 170px;
    height: 30px;
    margin: 15px;
    float: right;
  `;

  return (
    <BottomBarContainer>
      {buttonText &&(<CustomButton onClick={doSave}>{buttonText}</CustomButton>)}
      {isLoading && (<div>
        <div style={{width: "60%", display: "inline-block"}}><MatSpinner style={{padding: "20px"}}/></div>
        <div style={{width: "40%", display: "inline-block"}}><p style={{fontSize: 30, color: '#fff'}}>Saving...</p></div>
      </div>)}
      {error && (<span style={{fontSize: "20px", lineHeight: "60px", color: "#fff", marginLeft: "30px", border: "solid 3px red"}}>Error: {error}, try save again or contact with support team.</span>)}
    </BottomBarContainer>
  );
}
